/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Draft_No_Vat_ShortInputs */

const vi_einvoice_draft_no_vat_short = /** @type {(inputs: Einvoice_Draft_No_Vat_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không cộng VAT`)
};

/**

* @param {Einvoice_Draft_No_Vat_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_draft_no_vat_short = /** @type {((inputs?: Einvoice_Draft_No_Vat_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Draft_No_Vat_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_draft_no_vat_short(inputs)
});